const comparators = {
	date: (a, b) => a.eventId - b.eventId,
	tier: (a, b) => a.trophyTypeId - b.trophyTypeId || a.eventId - b.eventId,
};

export const TrophySortKeys = {
	date: "date",
	tier: "tier",
};

export function sortAwards(awards, { key, descending = true } = {}) {
	const compare = comparators[key] ?? comparators.date;

	return [...(awards ?? [])].sort((a, b) =>
		descending ? compare(b, a) : compare(a, b)
	);
}
